<!-- eslint-disable vue/no-unused-vars -->
<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="container-fluid">
    <Breadcrumbs main="Baseline Params" :path="breadcrumbPath" />
    <el-row class="m-0 width-100-p mt-3">
      <el-col class="d-flex align-item-center px-2" :span="24">
        <div class="row m-0 width-100-p px-2">
          <div
            class="row m-0 py-3 width-100-p bg-me-primary border-color-light rounded-4"
          >
            <el-row :gutter="$vuetify.display.width > 1200 ? 20 : 0">
              <!-- search bay -->
              <el-col
                    :span="$vuetify.display.width > 1200 ? 16 : 24"
                    :class="$vuetify.display.width > 1200 ? 'x-start order-1 mb-10' : 'x-start order-3 mb-10'"
                  >
                    <el-input
                      size="large"
                      v-model="search"
                        :placeholder="'Type to search by country, dispatch Int, charger type ...'"
                        :prefix-icon="Search"
                        class="mixedSearchBar-2"
                        id="mixedSearchBar-input-2"
                        clearable
                        @clear="handleReload"
                    >                      
                      <template #append>
                        <!-- <el-button :icon="Search" /> -->
                        <el-button
                            @click.stop="handleReload"
                            class="newSearchButtonClass"
                          >
                          <svg v-if="$vuetify.display.width > 800" class="width-115 height-40">
                            <use
                              href="@/assets/svg/newSvgIcon.svg#newSearchButtonIcon"
                            ></use>
                          </svg>
                          <svg v-else class="width-59 height-40" >
                            <use
                              href="@/assets/svg/newSvgIcon.svg#newSearchButtonIcon-small"
                            ></use>
                          </svg>
                        </el-button>
                      </template>
                    </el-input>

              </el-col>

              <!-- export button -->
              <el-col
                    :class="$vuetify.display.width > 1200 ? 'd-flex justify-content-end order-2' : 'd-flex justify-content-end order-1 mb-20'"
                    :span="$vuetify.display.width > 1200 ? 8 : 24"
                  >
                  <el-button
                      v-if="
                          $store.state.auth.user != null &&
                          !$store.state.auth.user.is_auditor
                        "
                      @click.stop="handleNew"
                      class="newAddButtonNoText new-button-behavior x-end"
                      size="small"
                    >
                        <svg class="width-40 height-40">
                          <use href="@/assets/svg/newSvgIcon.svg#newAddButtonNoText"></use>
                        </svg>
                    </el-button>
                    <el-button
                      @click.stop="handleExportFile"
                      class="new-download-file-btn new-button-behavior x-end"
                    >
                        <svg class="width-40 height-40">
                          <use href="@/assets/svg/newSvgIcon.svg#newDownloadFileIcon"></use>
                        </svg>
                    </el-button>
              </el-col>
            </el-row>

            <DataTable
              :loadingProp="loading"
              :usersDataProp="displayTableData"
              :totalRowProp="total_items"
              @tableAction="handleTableAction"
              :monitoringPeriodsProp="monitoringPeriods"
            />
          </div>
        </div>
      </el-col>
    </el-row>
    <ShowDetail
      :open_modal="show_modal"
      :data_modal="data_modal"
      :copiedDataProp="copiedData"
      @close_modal="close_modal"
      @confirm_modal="confirm_modal"
      :monitoringPeriodsProp="monitoringPeriods"
      @refreshBaselineData="handleRefreshBaselineData"
    />


  </div>
</template>

<script>
import Breadcrumbs from "../../components/bread_crumbs.vue";
// import XLSX from "xlsx";
import UserService from "../../services/user.service";
import DataTable from "./dataTable.vue";
// import Filter from "./filter.vue";
import ShowDetail from "./dialogDetail.vue";
import { ElMessageBox } from "element-plus";
import { exportToExcel } from "../dashboard/common/exportExcel";

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "baselines",
  components: {
    Breadcrumbs,
    // Filter,
    ShowDetail,
    DataTable,
  },
  data() {
    return {

      breadcrumbPath: [
        {
          title: "Input",
          disabled: true,
          href: "",
        },
        {
          title: "Baseline Params",
          disabled: false,
          href: "/baseline-params",
          active: true,
        },
      ],

      show: true,
      // baselineDataList: [],
      // pagination and search
      baselineDataList: [],
      beforeSearch: [],
      searchResult: [],
      displayTableData:[],
      search: "",
      current_page: 0,
      page_size: 50,
      total_items: 100,
      perPageCount: 50,


      loading: false,
      show_modal: false,
      data_modal: null,
      current_row_index: null,
      filterOpen: false,

      // fetching monitoring periods for select monitoring period dropdown
      monitoringPeriods: [],

      copiedData: null, // data copied from data table
    };
  },
  watch: {

    // pagination and search
    baselineDataList: {
      handler: "applySearch",
      immediate: true,
    },

    searchResult: {
      handler: "handlePaginatedData",
      immediate: true,
    },

    current_page: {
      handler: "handlePaginatedData",
      immediate: true,
    },

    page_size: {
      handler: "handlePaginatedData",
      immediate: true,
    },
    // pagination and search
  },
  computed: {
    filter_baseline() {
      // let list = this.baselineDataList.filter((item) => {
      //   return (
      //     (item.country === undefined ? "" : item.country)
      //       .toLowerCase()
      //       .indexOf(this.search.toLowerCase()) > -1 ||
      //     (item.charger_type === undefined ? "" : item.charger_type)
      //       .toLowerCase()
      //       .indexOf(this.search.toLowerCase()) > -1
      //   );
      // });
      // // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      // this.total_items = list.length;
      // let paginated = this.paginate(list, this.page_size, this.current_page);
      // return paginated;
      return this.baselineDataList;
    },

    // pagination for table data
    paginatedData() {
      let start = (this.current_page - 1 ) * this.page_size;
      let end = (start + this.page_size) >= this.searchResult.length ? (this.searchResult.length) : (start + this.page_size);
      let data = this.searchResult;
      return data.slice(start, end);
    },
  },
  mounted() {
    this.fetchBaselineData(1);
    this.fetchMonitoringPeriodData();
    this.copiedData = null; // reset copied data
  },
  methods: {

    // convertLabel(str) {
    //   return convertToTitleCase(str);
    // },

    // handleSelectSearchBy(search_by){
    //   this.selectedSearchBy = search_by;
    // },

    // fetching monitoring periods for select monitoring period dropdown
    async fetchMonitoringPeriodData() {
      // Start: Try from sessionStorage first
      const cached = sessionStorage.getItem("monitoringPeriods");
      if (cached) {
          try {
            const parsed = JSON.parse(cached);
            this.monitoringPeriods = parsed;
            return;
          } catch (err) {
            console.error("Error parsing sessionStorage monitoringPeriods");
            console.log("no monitoring periods in session data, fetching monitoring periods...");
          }
      }
      else {
        const response = await UserService.getMonitoringPeriods(null, "", 1, 50, true);
        const data = response.data.monitoring_periods || [];
        if (data.length > 0) {
          sessionStorage.setItem("monitoringPeriods", JSON.stringify(data));
          this.monitoringPeriods = data;
        } else {
          // no data in MP database, set selected mp name to '12 months'
          console.log('Monitoring periods data is empty');
          return;
        }
      }
    },

    handlePaginatedData() {
      this.displayTableData = this.paginatedData;
      // this.loadingBarChart = false;
    },

    applySearch(){
      let search = this.search;
      console.log("call search", search);

      if (search != "") {
        const term = search.toString().toLowerCase().trim();
        this.searchResult = [];
        let Result = this.beforeSearch.filter((item) => 
          item.country?.toString().toLowerCase().includes(term) ||
          item.dispatch_int?.toString().toLowerCase().includes(term)||
          item.charger_type?.toString().toLowerCase().includes(term)||
          item.fuel_emission_intensity?.toString().toLowerCase().includes(term)||
          item.afec?.toString().toLowerCase().includes(term)||
          item.mpg?.toString().toLowerCase().includes(term)||
          item.charger_efficiency?.toString().toLowerCase().includes(term)||
          item.tech_improvement_rate?.toString().toLowerCase().includes(term)||
          item.fuel_energy_density_MJ_gal?.toString().toLowerCase().includes(term)||
          item.fuel_energy_density_MJ_kWh?.toString().toLowerCase().includes(term)
        );

        this.searchResult = Result;
        this.total_items = Result.length;
        
      } else {
        let Result = this.beforeSearch;
        this.searchResult = Result;
        this.total_items = Result.length;
      }

    },

    handleRefreshBaselineData() {
      this.fetchBaselineData(1);
    },

  
    fetchBaselineData(page) {
      // bypass pagination
      UserService.getBaselineParams(null, null, page, this.perPageCount, true)
        .then(
          (response) => {
            this.baselineDataList = response.data.baseline_params;
            this.beforeSearch = response.data.baseline_params;
            this.total_items = response.data.total_record;



          },
          (error) => {
            this.loading = false;
            console.log(error);
            if (error.response.status == 401) {
              this.$router.push({
                path: "/",
              });
            }
          }
        ).then(
          () => {
            this.current_page = 1;
            this.page_size = 50;
          }
        )
        .catch((error) => {
          this.loading = false;
          console.log(error);
          if (error.response.status == 401) {
            this.$router.push({
              path: "/",
            });
          }
        })
        .finally(() => (this.loading = false));
    },
    DeleteBaseline(user, index) {
      UserService.deleteBaselineParam(user.id)
        .then(
          // eslint-disable-next-line no-unused-vars
          (response) => {
            this.baselineDataList.splice(index, 1);
            this.handleRefreshBaselineData();
          },
          (error) => {
            this.loading = false;
            console.log(error);
            if (error.response.status == 401) {
              this.$router.push({
                path: "/",
              });
            }
          }
        )
        .catch((error) => {
          this.loading = false;
          console.log(error);
          if (error.response.status == 401) {
            this.$router.push({
              path: "/",
            });
          }
        })
        .finally(() => (
          
          this.loading = false));
    },
    // eslint-disable-next-line no-unused-vars
    handleRowClick(row, column, event) {
      // console.log(row, column, event);
    },
    // eslint-disable-next-line no-unused-vars
    close_modal(event) {
      this.show_modal = false;
    },

    confirm_modal(event) {
      if (this.baselineDataList.length == this.current_row_index)
        this.baselineDataList.push(event);
      else this.baselineDataList[this.current_row_index] = event;
      this.show_modal = false;
    },

    handleShow(index, data) {
      this.current_row_index = index;
      this.data_modal = JSON.stringify(data);
      this.show_modal = true;
    },

    paginate(array, page_size, page_number) {
      return array.slice(
        (page_number - 1) * page_size,
        page_number * page_size
      );
    },

    async handleExportFile() {
      if (this.filter_baseline.length > 0) {

        const dataList = this.filter_baseline.map((row) => {
          const mapped = {};
          Object.keys(row).forEach((key) => {
            if (key === "monitoring_period_id") {
              const mp = this.monitoringPeriods.find(
                (period) => period.id == row.monitoring_period_id
              );
              mapped.monitoring_period =
                mp == null ? "" : mp.name == null ? mp.status_display : mp.name;
            } else {
              mapped[key] = row[key];
            }
          });
          return mapped;
        });
        const skipKeys = ["id"]; // Keys to skip
        const fileName = "BaselineList.xlsx"; // File name
        const newWorksheetName = "Baseline List"; // Worksheet name
        const title = "Baseline List"; // Title for the Excel file
        try {
        await exportToExcel({
          dataList,
          skipKeys,
          fileName,
          newWorksheetName,
          title,
        });
      } catch (error) {
        console.log("error when export excel", error.message);
      }
      }
    },

    // handleExportFile() {
    //   if (this.filter_baseline.length > 0) {
    //     const myHeader = [
    //       "country",
    //       "dispatch_int",
    //       "charger_type",
    //       "fuel_emission_intensity",
    //       "afec",
    //       "mpg",
    //       "charger_efficiency",
    //       "tech_improvement_rate",
    //       "fuel_energy_density_MJ_gal",
    //       "fuel_energy_density_MJ_kWh",
    //     ];
    //     const ws = XLSX.utils.json_to_sheet(this.filter_baseline, {
    //       header: myHeader,
    //     });
    //     const wb = XLSX.utils.book_new();
    //     XLSX.utils.book_append_sheet(wb, ws, "Data");
    //     XLSX.writeFileXLSX(wb, "BaselineList.xlsx");
    //   }
    // },

    reset_filter(event) {
      this.current_page = 1;
      this.search = "";
      this.filter = event.filter;
    },

    handleTableAction(event) {
      if (event.kind == "edit") {
        this.handleShow(event.index, event.data);
      } else if (event.kind == "delete") {
        this.deleteRow(event.data, event.index);
      } else if (event.kind == "changePage") {
        this.current_page = event.index;
        // this.fetchBaselineData(this.current_page);
      } else if (event.kind == "copy") {
        this.handleCopyRow(event.data, event.index);
      }
      else if (event.kind == "perPageChange") {
        this.current_page = 1;
        this.page_size = event.index;
        this.perPageCount = event.index;
        this.handleReload();
      }
    },

    handleCopyRow(event) {
      // console.log(event, index);
      this.copiedData = event;
    },

    handleReload() {
      // this.fetchBaselineData(this.current_page);
      this.current_page = 1;
      this.applySearch(this.search);
    },
    handleNew() {
      let data = {
        first_name: "",
        last_name: "",
        email: "",
        is_staff: false,
        is_superuser: false,
        is_active: true,
        baseline_id: null,
        id: 0,
        tech_improvement_rate: 1.0,
        fuel_energy_density_MJ_kWh: 3.6,
      };
      this.current_row_index = this.baselineDataList.length;
      this.data_modal = JSON.stringify(data);
      this.show_modal = true;
    },
    filterSearch(event) {
      this.search = event.search;
    },

    deleteRow(event, index) {
      console.log(event, index);
      ElMessageBox.confirm("Are you sure to delete this?", "info", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "Confirm Delete",
      })
        .then(() => {
          this.DeleteBaseline(event, index);
          // ElMessage({
          //   type: "success",
          //   message: "Delete completed",
          // });
        })
        .catch(() => {
          // ElMessage({
          //   type: "info",
          //   message: "Delete canceled",
          // });
        });
    },
  },
};
</script>

<style>
.el-table .warning-row {
  --el-table-tr-bg-color: var(--el-color-warning-light-8);
}
.el-table .error-row {
  --el-table-tr-bg-color: var(--el-color-error-light-8);
}

.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}

.cell {
  text-align: center !important;
}

.starter-main .card-body ul {
  list-style-type: none !important;
}

.el-pager {
  -webkit-user-select: none !important;
  user-select: none !important;
  list-style: none !important;
  font-size: 0 !important;
  padding: 0 !important;
  margin: 0 !important;
  display: flex !important;
  align-items: center !important;
  position: relative !important;
  top: 0 !important;
  right: 0 !important;
}

.el-upload-list {
  margin: 10px 0 0 !important;
  padding: 0 !important;
  list-style: none !important;
  position: relative !important;
}
</style>
